import { render, staticRenderFns } from "./Release_management_norms.vue?vue&type=template&id=28043490&scoped=true"
import script from "./Release_management_norms.vue?vue&type=script&lang=js"
export * from "./Release_management_norms.vue?vue&type=script&lang=js"
import style0 from "./Release_management_norms.vue?vue&type=style&index=0&id=28043490&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28043490",
  null
  
)

export default component.exports